import { useEffect, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';

import { reducer, initialState } from '../../reducers/actionReducer';
import FileSelection from '../../components/FileSelection';
import enhancementFileSelectionImage from '../../assets/business-solution-animate.svg';
import { FileImportSelector } from '../../components/actions/FileImportSelector';
import ActionModal from '../../components/ActionModal';
import ToastNotification from '../../components/ToastNotification';

export default function EnhancementsFileSelection() {
  const navigate = useNavigate();

  const [actionState, dispatchAction] = useReducer(reducer, initialState);
  const { success } = actionState;

  useEffect(() => {
    if (success) {
      navigate('/dashboard/mywork/files');
    }
  }, [navigate, success]);

  return (
    <>
      <FileSelection
        image={enhancementFileSelectionImage}
        prompt="Which file would you like to enhance?"
        UploadComponent={FileImportSelector}
        uploadComponentParams={{
          dispatchAction,
        }}
        uploadActionLabel="Select File"
        selectButtonTo="../../mywork/orders"
        selectButtonLabel="Browse Existing Audiences"
        dispatchAction={dispatchAction}
      />
      {actionState.inProgress && (
        <ActionModal
          actionState={actionState}
          dispatchAction={dispatchAction}
          show={actionState.inProgress}
        />
      )}
      <ToastNotification
        message={actionState.success}
        success={true}
        show={actionState.success}
      />
    </>
  );
}
